import React from "react";
import "./RedirectionScreen.css"
import Footer from "../HomeScreen/Footer/Footer";
import { Link } from "react-router-dom";

import logoWhite from "../../image/logo/logoWhite.webp"
import Qwhite from '../../image/logo/QWhite.webp'


const RedirectionScreen = () => {

    return (
        <>
        <div className='containerRedirection'>
            <div className="topBar">
                <Link to={"/"} className="containerLogo">
                    <img className="logoTopBar" src={logoWhite} />
                    <img className="logoTopBarTel" src={Qwhite} /> 
                </Link>
            </div>
            <div className="main">
                <p className="largeTextBold">Oups, la page que vous recherchez est introuvable.</p>
                <p className="largeTextBold">Essayez-en une autre !</p>
            </div>

            <Footer />
        </div>

        </>
    )
}

export default RedirectionScreen;